// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1SguD","title":"AfterFrontImage_title__1X5ng"};